import { useState } from "react";
import useInterval from "../../../hooks/useInterval";

const Ads = ["1", "2", "3", "4"].map((v) => (
    {src: process.env.PUBLIC_URL + "/Ad" + v + ".png", href: "https://smartnurse.notion.site/smartnurse/ENR-e58617d80cda481f90d976fa97d9916d" }
));

const DELAY_VALUE = 30000;

interface Props {
  compact?: boolean;
}

const Advertisement = ({ compact = false }: Props) => {
    const [idx, setIdx] = useState(0);

    useInterval(() => {
        if (compact) return;
        setIdx((idx + 1) % Ads.length);
    }, DELAY_VALUE);

    const ad = compact ? Ads[0] : Ads[idx];

    return (
        <a href={ad.href} target="_blank" rel="noreferrer">
            <img
                src={ad.src}
                alt="advertisement"
                style={{
                    display: 'block',
                    width: compact ? 'min(340px, calc(100vw - 112px))' : '100%',
                    height: 'auto',
                    maxHeight: compact ? 44 : undefined,
                    objectFit: 'contain',
                    flexShrink: 0,
                }}
            />
        </a>
    );
}

export default Advertisement;